// extracted by mini-css-extract-plugin
export default {"logoBlock":"Logo_logoBlock__V6i7j","logo":"Logo_logo__ThASg"};